import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Button } from 'react-bootstrap';
import Flex from '../Flex';

export const AdvanceTablePagination = ({
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageCount,
  pageIndex,
  gotoPage
}) => {
  // Function to calculate the range of pages to display
  const getPaginationRange = () => {
    let start = Math.max(0, pageIndex - 4);
    let end = Math.min(start + 15, pageCount - 1);
    start = Math.max(0, end - 15);

    return [...Array(end - start + 1)].map((_, idx) => start + idx);
  };

  return (
    <>
    <Flex alignItems="center" justifyContent="center">
      <Button
        size="sm"
        variant="falcon-default"
        onClick={() => previousPage()}
        className={classNames({ disabled: !canPreviousPage })}
      >
        <FontAwesomeIcon icon="chevron-left" /> Previous
      </Button>

      <ul className="pagination mb-0 mx-2">

        {getPaginationRange().map(page => (
          <li key={page} className={classNames({ active: pageIndex === page })}>
                {/* {JSON.stringify(page )} */}
            <Button
              size="sm"
              variant="falcon-default"
              className={classNames('page', { 'me-2': page + 1 !== pageCount })}
              onClick={() => gotoPage(page)}
            >
              {page + 1}
            </Button>
          </li>
        ))}
      </ul>
      <Button
  size="sm"
  variant="falcon-default"
  onClick={() => nextPage()}
  className={classNames({ disabled: !canNextPage })}
>
  Next <FontAwesomeIcon icon="chevron-right" />
</Button>

    </Flex>
    </>
  );
};

export default AdvanceTablePagination;
